import { useAppDispatch } from "../../store/hooks";
import { resetModals } from "../../store/slices/modalsSlice";

const ModalWrapper = ({ children, closeOnClick = false }) => {
  const dispatch = useAppDispatch();
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        zIndex: 999999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
      onClick={() => {
        if (closeOnClick) {
          dispatch(resetModals());
        }
      }}
    >
      {children}
    </div>
  );
};

export default ModalWrapper;
